import React, { useContext, useEffect, useRef, useState } from "react";
import GettingStartedContext from "../utils/GettingStartedContext";
import Dropdown from "../containers/dropdown-field";
import ArrowBottomIcon from "./arrow-botom-icon";
import FlightCalculator from "./flight-calculator/flight-calculator";

const PricingCostSection = ({
    paramId,
    disableFlightCalculator,
    widgetKey,
}) => {
    const mouseHandle = useRef();
    const [recommended, setRecommended] = useState(null);
    const [recommendedHour, setRecommendedHour] = useState(null);
    const [flightCalculatorOpened, setFlightCalculatorOpened] = useState(false);

    const [isVideoPopupOpen, setIsVideoPopupOpen] = useState(false);

    const openVideoPopup = () => {
        setIsVideoPopupOpen(true);
    };

    const closeVideoPopup = () => {
        setIsVideoPopupOpen(false);
    };

    const {
        hours,
        showResult,
        showSkip,
        ownership,
        link,
        lang,
        result,
        data,
        plan,
        plane,
        setPlan,
        setHours,
        isFr,
        isEn,
        formatNumber,
        getProperty,
        setShowResult,
        langString,
        setShowDownloadPricing,
        showToolTip,
        staticBlock,
        setStaticBlock,
        reloadResults,
        setReloadResults,
    } = useContext(GettingStartedContext);

    useEffect(() => {
        selectRecommendedHour();
    }, [recommended, data]);

    useEffect(() => {
        resetNumberAnimations();
        window.setTimeout(() => {
            loadInNumbers();
        }, 5);
    }, [plan, hours]);

    useEffect(() => {
        // select the default hours postion.
        if (mouseHandle.current && plan && plan.ID) {
            const input = document.querySelector('[data-id="' + plan.ID + '"]');
            const parent = input.parentNode;
            const closestContainerRect = parent.getBoundingClientRect();
            const container = document.querySelector(".gsa__form-hours-slider");
            const containerRect = container.getBoundingClientRect();
            document.querySelector(".gsa__form-hours-handle").style.left =
                closestContainerRect.x - containerRect.x + "px";
        }
    }, []);

    const selectRecommendedHour = () => {
        if (recommended > 0) {
            let distance = -1;
            let selectedId = -1;

            let recommendedH = Math.ceil(recommended / 60);
            let purchasedHours = 25;
            if (recommendedH >= 31 && recommendedH <= 60) {
                purchasedHours = 50;
            } else if (recommendedH >= 61 && recommendedH <= 90) {
                purchasedHours = 75;
            } else if (recommendedH >= 91 && recommendedH <= 115) {
                purchasedHours = 100;
            } else if (recommendedH >= 116 && recommendedH <= 140) {
                purchasedHours = 125;
            } else if (recommendedH >= 141) {
                purchasedHours = 150;
            }

            // console.log('PH', purchasedHours);

            data.Options.RelatedPlans.map((p) => {
                let d = purchasedHours - p.MaxHours;
                if (d < 0) {
                    d = d * -1;
                }
                // console.log('PH', purchasedHours);
                if (distance === -1) {
                    distance = d;
                }

                if (d <= distance) {
                    distance = d;
                    selectedId = p.ID;
                }
            });
            setRecommendedHour(selectedId);
        }
    };

    const getResultMatchingValue = (type) => {
        if (type === "Planes") {
            const p = getProperty(data.Options, "BestPlane");
            if (p) {
                return p.ID;
            }
        }
        if (type === "Ownerships") {
            const p = getProperty(data.Options, "BestOwnership");
            if (p) {
                return p.ID;
            }
        }
    };

    const loadInNumbers = () => {
        $(".gsa__costs__item .cost").addClass("text-focus-in");
    };

    const resetNumberAnimations = () => {
        $(".gsa__costs__item .cost").removeClass("text-focus-in");
    };

    const handleInputClick = (e) => {
        const input = e.target;
        const parent = input.parentNode;
        const closestContainerRect = parent.getBoundingClientRect();
        const container = document.querySelector(".gsa__form-hours-slider");
        const containerRect = container.getBoundingClientRect();
        document.querySelector(".gsa__form-hours-handle").style.left =
            closestContainerRect.x - containerRect.x + "px";
    };

    const enableMove = (e) => {
        if (mouseHandle.current) {
            mouseHandle.current.classList.add("track");
            document.addEventListener("mousemove", handleMove);
            document
                .querySelector(".gsa__cost-range")
                .addEventListener("mouseleave", handleMouseLeave);
        }
    };

    const handleMouseLeave = (e) => {
        handleMove(e);
        mouseUp(e);
    };

    const handleMove = (e) => {
        if (
            mouseHandle.current &&
            mouseHandle.current.classList.contains("track")
        ) {
            const container = document.querySelector(".gsa__form-hours-slider");
            const containerRect = container.getBoundingClientRect();
            let x = e.clientX - containerRect.x;

            const left = 30;
            const right = containerRect.width - 30;

            if (x < left) {
                x = left;
            }
            if (x > right) {
                x = right;
            }

            mouseHandle.current.style.left = x + "px";
        }
    };

    const mouseUp = (e) => {
        const container = document.querySelector(".gsa__form-hours-slider");
        const containerRect = container.getBoundingClientRect();
        const ul = document.querySelector(".js-form-house-ul");
        const lis = document.querySelectorAll(".js-form-house-ul li");

        if (mouseHandle.current) {
            let handleRect = mouseHandle.current.getBoundingClientRect();
            let closest = null;
            let closestDistance = 0;
            let closestContainerRect = null;
            for (let i = 0; i < lis.length; i++) {
                let li = lis[i];
                let liRect = li.getBoundingClientRect();
                if (closest == null) {
                    closest = li;
                    closestContainerRect = liRect;
                    closestDistance = handleRect.x - liRect.x;
                    if (closestDistance < 0) {
                        closestDistance = closestDistance * -1;
                    }
                } else {
                    let d = handleRect.x - liRect.x;
                    if (d < 0) {
                        d = d * -1;
                    }
                    if (d < closestDistance) {
                        closest = li;
                        closestDistance = d;
                        closestContainerRect = liRect;
                    }
                }
            }
            if (closest) {
                let input = closest.querySelector("input");
                let id = parseInt(input.getAttribute("data-id"));
                input.checked = true;
                mouseHandle.current.style.left =
                    closestContainerRect.x - containerRect.x + "px";
                for (let i = 0; i < data.Options.RelatedPlans.length; i++) {
                    if (data.Options.RelatedPlans[i].ID === id) {
                        setHours(data.Options.RelatedPlans[i].ID);
                        setPlan(data.Options.RelatedPlans[i]);
                        setReloadResults(!reloadResults);
                        // resetNumberAnimations();
                    }
                }
            }
        }

        mouseHandle.current.classList.remove("track");

        document.removeEventListener("mousemove", handleMove);
        document
            .querySelector(".gsa__cost-range")
            .removeEventListener("mouseleave", handleMouseLeave);
    };

    const findMatchingCTAButton = () => {
        if (data && data.Options) {
            for (const button of data.Options.CTAButtons) {
                const matched =
                    button.AirCraft === plane &&
                    button.Plan === hours &&
                    button.Ownership === ownership;
                if (matched) {
                    return button;
                }
            }
        }
        return null;
    };

    const isOnetimePurchase = () => {
        if (
            data.Options &&
            data.Options.Ownership &&
            data.Options.Ownership.Title
        ) {
            return data.Options.Ownership.ID === 1;
            // const title = data.Options.Ownership.Title.toLowerCase();
            // const description = data.Options.Ownership.Description.toLowerCase();
            // return title.includes("one time")
            //   || title.includes("one-time")
            //   || description.includes("one time")
            //   || description.includes("one-time")
            //   || title.includes("frais de")
            //   || description.includes("fes frais de location annuels"); // || (title.includes("capital"))
        }
        return false;
    };

    const goToResultsPage = () => {
        // let url = data.exploreOptionLink + '?aircraft='
        //   + plane + '&ownership='
        //   + ownership;
        let url = `${data.exploreOptionLink}?aircraft=${plane}&ownership=${ownership}&hours=${hours}&plan=${plan.ID}`;
        window.location = url;
    };

    const showVideoPopup = (e) => {
        e.preventDefault();
    };

    if (!showResult) {
        return null;
    }

    let downloadsClass = "gsa__costs__download";
    if (plan && plan.LeasingOptions && plan.LeasingOptions.DownloadLink) {
        downloadsClass += " gsa__costs__download--separator";
    }

    const ctaButton = findMatchingCTAButton();
    let planeOptionC, foundPlane;

    if (plane) {
        planeOptionC = data?.Options?.Planes || [];
        foundPlane = planeOptionC.find((p) => p.ID === plane);
    }
    const planeObj = plane ? foundPlane : null;

    return (
        <>
            <div className="gsa__costs" id="costs-section">
                <div className="grid-container grid-container--gsa">
                    <div className="grid-x align-center">
                        <div className="small-12 large-8">
                            <h3 className="gsa__costs-title">
                                {langString("SUMMARY_OF_ESTIMATED_COST")}
                            </h3>
                            <div className="gsa__costs-help">
                                <p>{langString("HOURS_SLIDER_TEXT")}</p>
                            </div>
                        </div>
                    </div>
                    {!showSkip && (
                        <>
                            <div className="gsa__costs__other">
                                <div className="grid-x">
                                    {/* <div className="small-12 medium-offset-1 medium-10 large-offset-0 large-12 xlarge-offset-1 xlarge-10"> */}
                                    <div className="small-12">
                                        <ul>
                                            {!staticBlock && (
                                                <li>
                                                    <label>
                                                        {langString(
                                                            "CHOOSE_YOUR_JET"
                                                        )}
                                                    </label>
                                                    <Dropdown
                                                        type="Planes"
                                                        link={link}
                                                        paramId={paramId}
                                                        lang={lang}
                                                        result={result}
                                                        defaultOption={getResultMatchingValue(
                                                            "Planes"
                                                        )}
                                                        defaultTitle={langString(
                                                            "CHOOSE_YOUR_JET_HOLDER"
                                                        )}
                                                        showResult={() => {
                                                            setShowResult(true);
                                                            resetNumberAnimations();
                                                        }}
                                                    />
                                                </li>
                                            )}
                                            <li>
                                                <label>
                                                    {langString(
                                                        "CHOOSE_YOUR_OWNERSHIP"
                                                    )}
                                                </label>
                                                <Dropdown
                                                    type="Ownerships"
                                                    link={link}
                                                    paramId={paramId}
                                                    lang={lang}
                                                    result={result}
                                                    defaultOption={getResultMatchingValue(
                                                        "Ownerships"
                                                    )}
                                                    defaultTitle={langString(
                                                        "CHOOSE_YOUR_OWNERSHIP_HOLDER"
                                                    )}
                                                    showResult={() => {
                                                        setShowResult(true);
                                                        resetNumberAnimations();
                                                    }}
                                                />
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                    <div className="grid-x gsa__cost-range">
                        {/* <div className="small-12 medium-offset-2 medium-8"> */}
                        <div className="small-12 medium-11">
                            <div className="js-range-slider gsa__cost-range-slider" />
                            <div className="gsa__form-hours-slider">
                                <ul className="js-form-house-ul">
                                    {data.Options.RelatedPlans.map(
                                        (option, index) => {
                                            return (
                                                <li key={option.ID}>
                                                    <input
                                                        type="radio"
                                                        id={
                                                            option.ID +
                                                            "-" +
                                                            index
                                                        }
                                                        name="option"
                                                        data-id={option.ID}
                                                        data-activehoursid={
                                                            hours
                                                        }
                                                        data-checked={
                                                            hours === option.ID
                                                        }
                                                        onChange={(e) => {
                                                            handleInputClick(e);
                                                            setHours(option.ID);
                                                            setPlan(option);
                                                            setReloadResults(
                                                                !reloadResults
                                                            );
                                                        }}
                                                        checked={
                                                            hours === option.ID
                                                        }
                                                    />
                                                    <label
                                                        htmlFor={
                                                            option.ID +
                                                            "-" +
                                                            index
                                                        }
                                                    >
                                                        <span
                                                            className="max-hours-num"
                                                            style={{
                                                                color:
                                                                    recommendedHour &&
                                                                    recommendedHour ===
                                                                        option.ID &&
                                                                    flightCalculatorOpened
                                                                        ? "#56c2ff"
                                                                        : "#fff",
                                                                fontWeight:
                                                                    recommendedHour &&
                                                                    recommendedHour ===
                                                                        option.ID &&
                                                                    flightCalculatorOpened
                                                                        ? "bolder"
                                                                        : "normal",
                                                            }}
                                                        >
                                                            {option.MaxHours}{" "}
                                                        </span>
                                                        <span
                                                            className="max-hours-hrs"
                                                            style={{
                                                                color:
                                                                    recommendedHour &&
                                                                    recommendedHour ===
                                                                        option.ID &&
                                                                    flightCalculatorOpened
                                                                        ? "#56c2ff"
                                                                        : "#fff",
                                                            }}
                                                        >
                                                            hrs
                                                        </span>
                                                    </label>
                                                    {recommendedHour &&
                                                        recommendedHour ===
                                                            option.ID &&
                                                        flightCalculatorOpened && (
                                                            <p
                                                                className={
                                                                    "gsa__form-hours-recommended"
                                                                }
                                                            >
                                                                <span className="gsa__form-hours-recommended-test">
                                                                    {langString(
                                                                        "RECOMMENDED"
                                                                    )}
                                                                </span>
                                                                {langString(
                                                                    "RECOMMENDED_TOOL_TIP"
                                                                ) && (
                                                                    <span
                                                                        className={
                                                                            "gsa__form-hours-recommended-popup"
                                                                        }
                                                                    >
                                                                        {langString(
                                                                            "RECOMMENDED_TOOL_TIP"
                                                                        )}
                                                                    </span>
                                                                )}
                                                            </p>
                                                        )}
                                                </li>
                                            );
                                        }
                                    )}
                                </ul>
                                <span
                                    className="gsa__form-hours-handle"
                                    ref={mouseHandle}
                                    onMouseDown={(e) => {
                                        enableMove(e);
                                    }}
                                    onMouseUp={(e) => {
                                        mouseUp(e);
                                    }}
                                ></span>
                            </div>
                        </div>
                    </div>
                </div>

                {!!(plane && !disableFlightCalculator) && (
                    <FlightCalculator
                        embedded={true}
                        widgetKey={widgetKey}
                        setRecommended={setRecommended}
                        setFlightCalculatorOpened={setFlightCalculatorOpened}
                        planeModel={planeObj ? planeObj.ModelID : ""}
                    />
                )}

                <div className="grid-container grid-container--gsa">
                    <div className="grid-x">
                        {/* <div className="small-12 medium-offset-2 medium-8 xlmedium-offset-3 xlmedium-6 large-offset-0 large-12"> */}
                        <div className="small-12">
                            <ul className="cost__results">
                                <li className="gsa__costs__item gsa__costs__deposit">
                                    <div>
                                        <h3>
                                            {langString(
                                                isOnetimePurchase()
                                                    ? "ONE_TIME_PAYMENT"
                                                    : "DEPOSIT"
                                            )}
                                        </h3>
                                        {plan &&
                                        plan.LeasingOptions.DepositText ? (
                                            <p className="cost cost-text">
                                                {isFr() &&
                                                plan.LeasingOptions
                                                    .DepositTextFR
                                                    ? plan.LeasingOptions
                                                          .DepositTextFR
                                                    : plan.LeasingOptions
                                                          .DepositText}
                                            </p>
                                        ) : (
                                            <>
                                                {!isNaN(
                                                    getProperty(
                                                        plan.LeasingOptions,
                                                        isFr()
                                                            ? "DepositFR"
                                                            : "Deposit",
                                                        "Deposit"
                                                    )
                                                ) === true ? (
                                                    <p className="cost">
                                                        {!!isEn() && (
                                                            <sup>$</sup>
                                                        )}
                                                        {formatNumber(
                                                            getProperty(
                                                                plan.LeasingOptions,
                                                                isFr()
                                                                    ? "DepositFR"
                                                                    : "Deposit",
                                                                "Deposit"
                                                            )
                                                        )}
                                                        {!!isFr() && (
                                                            <sup>$</sup>
                                                        )}
                                                    </p>
                                                ) : (
                                                    <p className="cost">
                                                        {!!isEn() && (
                                                            <sup>$</sup>
                                                        )}
                                                        {isFr() &&
                                                        plan.LeasingOptions
                                                            .DepositFR
                                                            ? plan
                                                                  .LeasingOptions
                                                                  .DepositFR
                                                            : plan
                                                                  .LeasingOptions
                                                                  .Deposit}
                                                        {!!isFr() && (
                                                            <sup>$</sup>
                                                        )}
                                                    </p>
                                                )}
                                            </>
                                        )}
                                        <div className="label">
                                            <div className="label-inner">
                                                <span>
                                                    {langString(
                                                        isOnetimePurchase()
                                                            ? "ONE_TIME_PAYMENT_HINT"
                                                            : "LEASE_DEPOSIT_HINT"
                                                    )}
                                                </span>
                                                {showToolTip(
                                                    isOnetimePurchase()
                                                        ? "ONE_TIME_PAYMENT_TOOLTIP"
                                                        : "LEASE_DEPOSIT_TOOLTIP"
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </li>

                                {!isOnetimePurchase() && (
                                    <li className="gsa__costs__item gsa__costs__annual">
                                        <div>
                                            <h3>{langString("ANNUAL_FEE")}</h3>
                                            {plan.LeasingOptions.LeaseText ? (
                                                <p className="cost cost-text">
                                                    {isFr() &&
                                                    plan.LeasingOptions
                                                        .LeaseTextFR
                                                        ? plan.LeasingOptions
                                                              .LeaseTextFR
                                                        : plan.LeasingOptions
                                                              .LeaseText}
                                                </p>
                                            ) : (
                                                <p className="cost">
                                                    {!!isEn() && <sup>$</sup>}
                                                    {formatNumber(
                                                        getProperty(
                                                            plan.LeasingOptions,
                                                            "Lease"
                                                        )
                                                    )}
                                                    {!!isFr() && <sup>$</sup>}
                                                </p>
                                            )}
                                            <div className="label">
                                                <div className="label-inner">
                                                    <span>
                                                        {langString(
                                                            "ANNUAL_FEE_HINT"
                                                        )}
                                                    </span>
                                                    {showToolTip(
                                                        "ANNUAL_FEE_TOOLTIP"
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                )}

                                <li className="gsa__costs__item">
                                    <div>
                                        {plan.LeasingOptions &&
                                        plan.LeasingOptions.ManagementText ? (
                                            <p className="cost cost-text">
                                                {isFr() &&
                                                plan.LeasingOptions
                                                    .ManagementTextFR
                                                    ? plan.LeasingOptions
                                                          .ManagementTextFR
                                                    : plan.LeasingOptions
                                                          .ManagementText}
                                            </p>
                                        ) : (
                                            <p className="cost">
                                                {!!isEn() && <sup>$</sup>}
                                                {formatNumber(
                                                    getProperty(
                                                        plan.LeasingOptions,
                                                        "Management"
                                                    )
                                                )}
                                                {!!isFr() && <sup>$</sup>}
                                            </p>
                                        )}
                                        <div className="label">
                                            <div className="label-inner">
                                                <span>
                                                    {langString("ANNUAL_MGMT")}
                                                </span>
                                                {showToolTip(
                                                    "ANNUAL_MGMT_TOOLTIP"
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </li>
                                <li className="gsa__costs__item">
                                    <div>
                                        <p className="cost">
                                            {!!isEn() && <sup>$</sup>}
                                            {formatNumber(
                                                getProperty(
                                                    plan.LeasingOptions,
                                                    "OccupiedHRRate"
                                                )
                                            )}
                                            {!!isFr() && <sup>$</sup>}
                                        </p>
                                        <div className="label">
                                            <div className="label-inner">
                                                <span>
                                                    {langString(
                                                        "OCCUPIED_HR_RATE"
                                                    )}
                                                </span>
                                                {showToolTip(
                                                    "OCCUPIED_HR_RATE_TOOLTIP"
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </li>
                                <li className="gsa__costs__item">
                                    <div>
                                        <p className="cost">
                                            {!!isEn() && <sup>$</sup>}
                                            {formatNumber(
                                                getProperty(
                                                    plan.LeasingOptions,
                                                    "RepositioningCost"
                                                )
                                            )}
                                            {!!isFr() && <sup>$</sup>}
                                        </p>
                                        <div className="label">
                                            <div className="label-inner">
                                                <span>
                                                    {langString(
                                                        "REPOSITIONING_COST"
                                                    )}
                                                </span>
                                                {showToolTip(
                                                    "REPOSITIONING_COST_TOOLTIP"
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>

                    {isVideoPopupOpen && (
                        <div id="popup" class="popup">
                            <span class="close-popup" onClick={closeVideoPopup}>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                >
                                    <path
                                        d="M16.2887 14.9617C16.4649 15.1378 16.5638 15.3767 16.5638 15.6258C16.5638 15.8749 16.4649 16.1137 16.2887 16.2898C16.1126 16.466 15.8737 16.5649 15.6247 16.5649C15.3756 16.5649 15.1367 16.466 14.9606 16.2898L10.0005 11.3281L5.03874 16.2883C4.86261 16.4644 4.62374 16.5633 4.37467 16.5633C4.1256 16.5633 3.88673 16.4644 3.71061 16.2883C3.53449 16.1122 3.43555 15.8733 3.43555 15.6242C3.43555 15.3751 3.53449 15.1363 3.71061 14.9602L8.67233 10L3.71217 5.03828C3.53605 4.86216 3.43711 4.62329 3.43711 4.37422C3.43711 4.12515 3.53605 3.88628 3.71217 3.71016C3.88829 3.53404 4.12716 3.43509 4.37624 3.43509C4.62531 3.43509 4.86418 3.53404 5.0403 3.71016L10.0005 8.67188L14.9622 3.70937C15.1383 3.53325 15.3772 3.43431 15.6262 3.43431C15.8753 3.43431 16.1142 3.53325 16.2903 3.70937C16.4664 3.88549 16.5654 4.12437 16.5654 4.37344C16.5654 4.62251 16.4664 4.86138 16.2903 5.0375L11.3286 10L16.2887 14.9617Z"
                                        fill="#ffffff"
                                    />
                                </svg>
                            </span>
                            <iframe
                                id="youtube-iframe"
                                src={`https://fast.wistia.net/embed/iframe/${data.ResultsExplanationVideo}?autoplay=1`}
                                frameborder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowfullscreen
                            ></iframe>
                        </div>
                    )}

                    <div className={downloadsClass}>
                        <ul>
                            {!!ctaButton && (
                                <li className="costs__cta_button">
                                    <a
                                        href={ctaButton.Link}
                                        target={
                                            ctaButton.Target
                                                ? "_blank"
                                                : "_self"
                                        }
                                        className="button secondary"
                                    >
                                        {ctaButton.Title}
                                    </a>
                                </li>
                            )}

                            {!!data.ResultsExplanationVideo && (
                                <li
                                    className="gsa__costs__watch w-auto js-open-video"
                                    onClick={openVideoPopup}
                                >
                                    <p id="costwatchtext">
                                        {langString(
                                            "UNDERSTANDING_THE_NUMBERS"
                                        )}
                                        <br />
                                        <span
                                            className="v-btn"
                                            href={data.ResultsExplanationVideo}
                                        >
                                            {langString("WATCH_VIDEO_NOW")}
                                        </span>
                                    </p>
                                    <div
                                        className="gsa__costs__watch__image"
                                        id="costwatchimage"
                                    >
                                        <span>
                                            <img
                                                src={
                                                    data.ResultsExplanationVideoImage
                                                }
                                            />
                                        </span>
                                        <svg
                                            id="Group_462"
                                            data-name="Group 462"
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="20"
                                            height="20"
                                            viewBox="0 0 20 20"
                                        >
                                            <circle
                                                id="Ellipse_34"
                                                data-name="Ellipse 34"
                                                cx="10"
                                                cy="10"
                                                r="10"
                                                fill="#5ac3ff"
                                            />
                                            <path
                                                id="select-arrows"
                                                d="M3.284,0,0,4.6H6.567L3.284,0Zm0,10.294h0L0,7.224Z"
                                                transform="translate(13.326 6.564) rotate(90)"
                                                fill="#fff"
                                            />
                                        </svg>
                                    </div>
                                </li>
                            )}
                            {data.exploreButtonTitle && (
                                <li className={"w-xl-auto"}>
                                    <a
                                        onClick={(e) => {
                                            e.preventDefault();
                                            goToResultsPage();
                                        }}
                                        className="button secondary"
                                    >
                                        {data.exploreButtonTitle}
                                    </a>
                                </li>
                            )}
                            {!!getProperty(
                                plan.LeasingOptions,
                                "DownloadLink"
                            ) &&
                                !data.exploreButtonTitle && (
                                    <li className="w-xl-auto">
                                        <a
                                            onClick={(e) => {
                                                e.preventDefault();
                                                setShowDownloadPricing(true);
                                            }}
                                            className="button secondary"
                                            download
                                        >
                                            {langString("DOWNLOAD_PRICING")}
                                            <ArrowBottomIcon />
                                        </a>
                                    </li>
                                )}
                        </ul>
                        {!!langString("DOWNLOAD_PRICING_BUTTON_FOOT_NOTE") && (
                            <div
                                className="gsa__costs__download-help"
                                dangerouslySetInnerHTML={{
                                    __html: langString(
                                        "DOWNLOAD_PRICING_BUTTON_FOOT_NOTE"
                                    ),
                                }}
                            ></div>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default PricingCostSection;
